// @flow

export const location: Location = window.location
export const history: History = window.history



// WEBPACK FOOTER //
// ./src/frame/core/window.js